import React, { useState } from 'react';
import { Button } from 'antd';

function CopyToClipboard(props) {
    const { text, node = () => <button />, ...others } = props;
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      // 提供短暂的视觉反馈后重置状态
      setTimeout(() => setCopied(false), 2000); // 2秒后恢复
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Button size='small' onClick={handleCopy} className="copy-button" {...others}>
    {copied ? '已复制' : '复制'}
    </Button>
  );
}

export default CopyToClipboard;